/**
 * Settings > Notifications: the way to the server's own Notification
 * settings (2026-10-29), which also open from the server's menu. Hidden while
 * the Console's `notifications` flag is off.
 */
import { guildLevel } from '@neosocial/protocol';
import { useT } from '../i18n';
import { useFlag } from '../store/config';
import { useData } from '../store/data';
import { useActiveGuildId } from '../store/selectors';
import { Btn } from '../ui/kit';
import { SetGroup, SetRow } from '../settings/Settings';
import { levelName, mutedUntil } from './labels';
import { openNotifyDialog } from './NotifyDialog';
import { isGuildMuted, serverDefault, settingsIn } from './rules';

export function ServerNotifyLink() {
  const { t } = useT();
  const on = useFlag('notifications');
  const gid = useActiveGuildId();
  const name = useData((d) => (gid ? (d.guilds[gid]?.name ?? '') : ''));
  const sub = useData((d) => {
    if (!gid) return '';
    const s = settingsIn(d, gid);
    return isGuildMuted(d, gid)
      ? mutedUntil(s?.mute_config)
      : levelName(guildLevel(s, serverDefault(d, gid)));
  });
  if (!on || !gid) return null;
  return (
    <SetGroup title={t('nt.set.group')}>
      <SetRow label={name} sub={sub}>
        <Btn kind="secondary" size="sm" icon="bell" onClick={() => openNotifyDialog(gid)}>
          {t('nt.set.open')}
        </Btn>
      </SetRow>
    </SetGroup>
  );
}
